module.exports = __webpack_public_path__ + "img/video-pic02.25b8aaad.png";